// ILF Product Collapsible Row — <ilf-product-collapsible-row>
// Accordion row: the toggle button flips the is-open class; all animation
// (grid-rows collapse, chevron rotation, content fade) lives in
// ilf-product-collapsible-row.css.

if (!customElements.get('ilf-product-collapsible-row')) {
  class IlfProductCollapsibleRow extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.toggleButton = this.querySelector('.row-toggle');
      this.onToggle = this.onToggle.bind(this);
      this.toggleButton?.addEventListener('click', this.onToggle);
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.onToggle);
      this.initialised = false;
    }

    onToggle() {
      const open = this.classList.toggle('is-open');
      this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');

      // Accordion mode: opening this row collapses its sibling rows (scoped to
      // the same product info column when present).
      if (open && this.dataset.autoCollapse === 'true') {
        const scope = this.closest('.ilf-product__info-container') || document;
        scope.querySelectorAll('ilf-product-collapsible-row.is-open').forEach((row) => {
          if (row === this) return;
          row.classList.remove('is-open');
          row.querySelector('.row-toggle')?.setAttribute('aria-expanded', 'false');
        });
      }
    }
  }

  customElements.define('ilf-product-collapsible-row', IlfProductCollapsibleRow);
}
